import type {FlexSuiteDetailsPage} from '../types'

export type DetailsTemplateProps = {
  page: FlexSuiteDetailsPage
}

export function DetailsTemplate({page}: DetailsTemplateProps) {
  return <div data-page-path={page.fields.path}>Hello world</div>
}
